import { t } from 'i18next';

import EmailDocumentsDialog from '~components/EmailDocumentsDialog/EmailDocumentsDialog';
import { OutboundEmailEntry } from '~hooks/useOutboundEmails/sendOutboundEmails';
import useSettlementEmailDraftsQuery from '~queries/useSettlementEmailDraftsQuery';

interface EmailSettlementsDialogProps {
  companyId: string;
  isOpen: boolean;
  onClose: () => void;
  onSend: (emails: OutboundEmailEntry[]) => Promise<void>;
  settlementIds: string[];
}

function EmailSettlementsContent({
  companyId,
  onClose,
  onSend,
  settlementIds,
}: Omit<EmailSettlementsDialogProps, 'isOpen'>) {
  const { drafts, isError, isLoading, refetch } = useSettlementEmailDraftsQuery(
    companyId,
    settlementIds,
  );
  const emailCount = drafts?.length || settlementIds.length;

  return (
    <EmailDocumentsDialog
      drafts={drafts}
      isError={isError}
      isLoading={isLoading}
      labels={{
        description: t('approvals.driver_pay.settlements.email_settlement.description', {
          count: emailCount,
        }),
        noEmails: t('approvals.driver_pay.settlements.email_settlement.no_emails'),
        send: t('approvals.driver_pay.settlements.email_settlement.send', {
          count: emailCount,
        }),
        title: t('approvals.driver_pay.settlements.email_settlement.title', {
          count: emailCount,
        }),
      }}
      onClose={onClose}
      onRetry={refetch}
      onSend={onSend}
    />
  );
}

export default function EmailSettlementsDialog({
  isOpen,
  ...contentProps
}: EmailSettlementsDialogProps) {
  return isOpen ? <EmailSettlementsContent {...contentProps} /> : null;
}
